export type { CampaignData, ICampaignStore } from './types';

import { CampaignStore } from './store';

export const useCampaignStore = CampaignStore.getInstance;
